import { render, staticRenderFns } from "./VersionBrowser.vue?vue&type=template&id=e4b9cfe4&scoped=true&"
import script from "./VersionBrowser.vue?vue&type=script&lang=js&"
export * from "./VersionBrowser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4b9cfe4",
  null
  
)

export default component.exports